import { scaleBand, scaleLinear } from '@visx/scale';
/**
 * Given an array of objects and an accessor function, return the minimum and
 * maximum values for all elements in the array.
 */
export function getMinMax(d, accessor, min, max) {
    var vals = d.map(accessor);
    return [
        typeof min === 'number' ? min : Math.min.apply(Math, vals),
        typeof max === 'number' ? max : Math.max.apply(Math, vals)
    ];
}
export function generatePath(_a) {
    var data = _a.data, xScale = _a.xScale, yScale = _a.yScale, yMax = _a.yMax, accessors = _a.accessors;
    return data.reduce(function (path, datum, i) {
        var _a, _b;
        var barWidth = xScale.bandwidth();
        var yValue = accessors.y(datum);
        var xValue = accessors.x(datum);
        var bh = yMax - ((_a = yScale(yValue)) !== null && _a !== void 0 ? _a : 0); // bottom of the charting area
        var barX = (_b = xScale(xValue)) !== null && _b !== void 0 ? _b : 0; // left-most coordinate of the bar
        var barY = yMax - bh; // top edge of the bar
        var barPath = path;
        // If first bar:
        // Move to bottom - left corner of charting area
        if (i === 0) {
            barPath = "M 0 " + yMax;
        }
        // Draw rectangle from bottom-left to bottom-right
        barPath = barPath + " V " + barY + " H " + (barX + barWidth);
        // If last bar:
        if (i === data.length - 1) {
            // close path from bottom - right of last bar to bottom - left of first bar
            barPath = barPath + " V " + yMax + " Z";
        }
        return barPath;
    }, '');
}
export function generateScalesMap(_a) {
    var series = _a.series, accessors = _a.accessors, xMax = _a.xMax, barHeight = _a.barHeight, yMin = _a.yMin, yMax = _a.yMax;
    var indexedScales = Object.entries(series).reduce(function (scalesById, _a) {
        var key = _a[0], s = _a[1];
        var data = accessors.data(s);
        var xScale = scaleBand({
            range: [0, xMax],
            domain: data.map(accessors.x),
            round: false
        }); // TODO: Resolve typing for banded scales confict with time scales
        var yScale = scaleLinear({
            range: [barHeight, 0],
            domain: getMinMax(data, accessors.y, yMin, yMax)
        });
        var scales = {
            xScale: xScale,
            yScale: yScale
        };
        scalesById[key] = scales;
        return scalesById;
    }, {});
    return indexedScales;
}
//# sourceMappingURL=utils.js.map